import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import {
  IGetApiResponse,
  IShipkeyApiCredential,
  IShipstationApiCredential,
  IShopifyApiCredential,
  IAppIntegrationAccount,
} from '../../../interfaces';
import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class AppIntegrationAccountApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  delete(id :number) :Observable<any> {
    return this.apiService.delete(
      `${this.environment.urlV2}/app-integration-accounts/${id}`,
    );
  }

  update(id :number, data :IAppIntegrationAccount) :Observable<any> {
    return this.apiService.put(
      `${this.environment.urlV2}/app-integration-accounts/${id}`,
      data,
    );
  }

  create(data :IAppIntegrationAccount) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/app-integration-accounts`,
      body: data,
    });
  }

  get(params :{ [param :string] :string | string[] }) :Observable<IGetApiResponse> {
    return this.apiService.get(
      `${this.environment.urlV2}/app-integration-accounts`,
      { params },
    );
  }

  getById(id :number) :Observable<IAppIntegrationAccount> {
    return this.apiService.get(
      `${this.environment.urlV2}/app-integration-accounts/${id}`,
      {},
    );
  }

  getRules() :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/app-integration-accounts/credentials/rules`,
    );
  }

  getRulesByAccountType(params :{
    [param :string] :string | string[];
  }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/app-integration-accounts/credentials/rules`,
      { params },
    );
  }

  testOmsCredentials(
    app :string,
    credentials :| IShopifyApiCredential
      | IShipkeyApiCredential
      | IShipstationApiCredential,
  ) {
    return this.apiService.put(
      `${this.environment.urlV2}/app-integration-accounts/credentials/${app}`,
      credentials,
    );
  }

  getOAuthAuthorizationUrl(appIntegractionAccountId :number) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/app-integration-accounts/${appIntegractionAccountId}/oauth-authorization-url`,
    );
  }

  getIntegrationAppsFromActions(params :{
    [param :string] :string | string[];
  }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/app-integration-accounts/actions`,
      { params },
    );
  }
}
